import { DatabaseFieldType } from '@databases/types/database';
import { DatabaseFilterType } from '@databases/types/database/view';

import { containsNodeType } from '@canvas/adf/contains-node-type';
import { toMarkdown } from '@canvas/adf/to-markdown';
import { getExperimentValue } from '@canvas/client-feature-flags/experiments';

import type { FieldType } from '../field-types.ts';

import {
  parseTextBasedFromHtml,
  renderTextBasedExportView
} from './textBasedFieldType.ts';

const aiSummaryFieldType: FieldType<DatabaseFieldType.AI_SUMMARY> = {
  supportedFilterTypes: [
    DatabaseFilterType.EQUALS,
    DatabaseFilterType.CONTAINS,
    DatabaseFilterType.EMPTY
  ],

  // AI Summary is registered for safe round-tripping only. Keep import disabled
  // until the field is intentionally exposed through UI/generation flows.
  isCsvImportSupported: false,

  renderExportView: ({ value }) => renderTextBasedExportView(value),

  parseFromHtml: parseTextBasedFromHtml,

  convertFrom: {
    [DatabaseFieldType.TEXT]: ({ value }) => value
  },

  getInitialValue: () => ({ plain: '' }),

  isEmptyValue: ({ value }) => !value.plain,

  isEqualValue: ({ value: value1 }, { value: value2 }) => value1.plain === value2.plain,

  getCsvRepresentation: ({ value }) => {
    const isAiSummaryEnabled = getExperimentValue(
      'databasesFrontendAiFieldsSummary',
      'enabled',
      { fireExperimentExposure: false }
    );

    if (
      !isAiSummaryEnabled ||
      !value.rich ||
      !containsNodeType(value.rich, 'bulletList')
    ) {
      return value.plain;
    }

    return toMarkdown(value.rich).replace(/\n$/, '');
  },

  getStringRepresentation: ({ value }) => value.plain
};

export default aiSummaryFieldType;
